import React from "react";
import { IconControl } from "spark-core-dx/components";
import {
  getSectionStepLabel,
  getSectionStepNavigationItems
} from "./resourceConfigWizardUtils";

const WizardSingleSectionStatus = ({
  sectionSteps,
  activeSectionStepKey,
  wizard,
  stepKey,
  onRequestEditSectionStep
}) => {
  const [navigationItem] = getSectionStepNavigationItems(sectionSteps, wizard, stepKey, activeSectionStepKey);
  if (!navigationItem) return null;

  const {
    sectionStep,
    sectionStepKey,
    completed,
    canEditPrevious,
    showCompletedBadge
  } = navigationItem;
  const canEdit = canEditPrevious && typeof onRequestEditSectionStep === "function";
  const showComplete = showCompletedBadge || (completed && canEditPrevious && !canEdit);
  const label = getSectionStepLabel(sectionStep);

  if (canEdit) {
    return (
      <button
        type="button"
        className="resource-wizard__single-section-step-action resource-wizard__single-section-step-action--edit"
        title={`Edit ${label}`}
        aria-label={`Edit ${label}`}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onRequestEditSectionStep(sectionStepKey);
        }}
      >
        <IconControl iconKey="edit" width="0.85rem" height="0.85rem" />
      </button>
    );
  }

  if (showComplete) {
    return (
      <span
        className="resource-wizard__single-section-step-action resource-wizard__single-section-step-action--complete"
        title={`${label} complete`}
        aria-label={`${label} complete`}
      >
        <span className="material-symbols-rounded" aria-hidden="true">check</span>
      </span>
    );
  }

  return null;
};

export default WizardSingleSectionStatus;
